<script lang="ts">
	import {uqn} from './stores';
	import Katex from './Katex.svelte';
	import factorial from './functions/factorial';
	import numberWithCommas from './functions/numberWithCommas';

	let n: number, m:number;
	$: n = Number($uqn.toString()[0]);
	$: m = Number($uqn.toString()[1]);
	let ai: string, aii: string, aiii: string, aiv: string, bi: string, bii: string, biii: string, biv: string;
	$: ai = (2*m+2*n).toString() + "!=" + numberWithCommas(factorial(2*m+2*n));
	$: aii = (n+2*m).toString() + "!\\times 2!^" + n.toString() + "=" + numberWithCommas(factorial(n+2*m)*Math.pow(2,n));
	$: aiii = (n+m).toString() + "!\\times " + (n+m).toString() + "!\\times 2=" + numberWithCommas(Math.pow(factorial(n+m),2)*2);
	$: aiv = (n+m).toString() + "!" + mFactorialToString(m) + "\\times 2=" + numberWithCommas(factorial(n+m)*factorial(m)*2);	
	$: bi = (2*m+2*n-1).toString() + "!=" + numberWithCommas(factorial(2*m+2*n-1));
	$: bii = (n+2*m-1).toString() + "!\\times 2!^" + n.toString() + "=" + numberWithCommas(factorial(n+2*m-1)*Math.pow(2,n));
	$: biii = (n+m-1).toString() + "!\\times " + (n+m).toString() + "!=" + numberWithCommas(factorial(n+m-1)*factorial(n+m));
	$: biv = (n+m-1).toString() + "!" + mFactorialToString(m) + "\\times 2!=" + numberWithCommas(factorial(n+m-1)*factorial(m)*2);

	function mFactorialToString(m:number): string{
		if (m<2){
			return ""
		} else{
			return "\\times " + m.toString() + "!"
		}
	}
</script>


<div>
	<p>(ai) <Katex math={ai}/> </p>
	<p>(aii) <Katex math={aii}/> </p>
	<p>(aiii) <Katex math={aiii}/> </p>
	<p>(aiv) <Katex math={aiv}/> </p>
	<p>(bi) <Katex math={bi}/> </p>
	<p>(bii) <Katex math={bii}/> </p>
	<p>(biii) <Katex math={biii}/> </p>
	<p>(biv) <Katex math={biv}/> </p>
</div>


